import {
    IStatusType,
} from '../types';

export function formatTitle(type: IStatusType): string {
    switch (type) {
        case 'SUCCESS': {
            return 'Payment Successful';
        }
        case 'FAILED': {
            return 'Payment Failed';
        }
        case 'NOT_FOUND': {
            return 'Payment Not Found';
        }
    }
}
